import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './DeliverySummary.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectedStore,
  selectedDeliverySettings,
  assortmentsLoading,
  sitesLoading
} from '../../../selectors/assortments';
import { AppState } from '../../../reducers';
import { openSideModal } from '../../../slices/sideModalSlice';
import { SideModalTabs } from '../../SideModal';
import { Icons } from '@citygross/icons';
import Skeleton from 'react-loading-skeleton';
import { setCurrentStep } from '../../../slices/deliveryPickerSlice';
import { theme } from '@citygross/design-tokens';

export const DeliverySummary = () => {
  const dispatch = useDispatch();
  const isSitesLoading = useSelector((state: AppState) => sitesLoading(state));
  const store = useSelector((state: AppState) => selectedStore(state));
  const activeDeliverySettings = useSelector((state: AppState) =>
    selectedDeliverySettings(state)
  );
  const loading = useSelector(assortmentsLoading);

  return (
    <div className="c-cart-delivery-box">
      <div className="c-cart-first-delivery-time">
        {!activeDeliverySettings.deliveryMethod ? (
          !isSitesLoading && (
            <Fragment>
              <button
                className="c-change-delivery-link"
                onClick={() => {
                  dispatch(setCurrentStep({ currentStep: 0, previousStep: 0 }));
                  dispatch(openSideModal(SideModalTabs.STORE_SELECTOR));
                }}
              >
                Välj butik
              </button>

              <span>för att se ditt sortiment</span>
            </Fragment>
          )
        ) : (
          <Fragment>
            <span className="c-cart-first-delivery-icon">
              <Icons.Store
                color={theme.palette?.alertBlue}
                height={20}
                width={20}
              />
            </span>

            <span>Vald butik</span>

            {loading ? (
              <Skeleton width={120} />
            ) : (
              <button
                aria-label={`Vald butik ${store?.name}`}
                className="c-change-delivery-link"
                id="store-selector"
                onClick={() =>
                  dispatch(openSideModal(SideModalTabs.STORE_SELECTOR))
                }
              >
                {store?.name}
              </button>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

DeliverySummary.propTypes = {
  deliveryMethod: PropTypes.string,
  notLoggedIn: PropTypes.bool,
  openInFlyout: PropTypes.func,
  siteId: PropTypes.number,
  zipCode: PropTypes.string
};

DeliverySummary.defaultProps = {
  zipCode: null
};

export default DeliverySummary;
